document.querySelectorAll('[data-collection-swiper]').forEach((element) => {
  new Swiper(element, {
    loop: true,
    speed: 560,
    slidesPerView: 1,
    autoHeight: true,
    navigation: {
      prevEl: element.querySelector('[data-swiper-prev]'),
      nextEl: element.querySelector('[data-swiper-next]')
    },
    pagination: {
      el: element.querySelector('[data-swiper-pagination]'),
      clickable: true
    },
    a11y: {
      prevSlideMessage: '前の写真',
      nextSlideMessage: '次の写真'
    }
  });
});
